import React from 'react';
import PropTypes from 'prop-types';
import SessionStore from 'stores/SessionStore';
import AdminWebAPIUtils from 'utils/AdminWebAPIUtils';
import WhiteLabel from 'utils/whitelabel.js';
import CargomaticInput from 'components/v2/input';
import { isInternetExplorer } from 'utils/browser';
import { withTranslation } from 'react-i18next';
import CacheBusting from 'components/CacheBusting';
import LoadingCircle from 'components/ui/LoadingCircle';
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.updateField = (value, field) => {
            this.setState({ [field]: value });
        };
        this.handleLoginButton = async () => {
            const { email, password } = this.state;
            const isValid = this.validate();
            if (isValid) {
                this.setState({ loading: true });
                const loginResults = await AdminWebAPIUtils.login(email, password).catch((e) => {
                    console.log('ERR: ', e);
                });
                this.setState({ loading: false });
                return loginResults;
            }
        };
        this._handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                this.handleLoginButton();
            }
        };
        this.handlePasswordReset = () => {
            AdminWebAPIUtils.requestPasswordReset(this.state.email);
            this.setState({ mode: 'login' });
        };
        this.handleForgotPassword = () => {
            this.setState({ mode: 'forgot-password', email: '' });
        };
        this.state = {
            error: SessionStore.getError(),
            showPasswordReset: false,
            showIEWarning: false,
            logo: '',
            email: '',
            password: '',
            mode: 'login', // login, forgot-password, reset-password
            loading: false,
        };
    }
    async componentDidMount() {
        this.setState({ showIEWarning: isInternetExplorer() });
        SessionStore.addChangeListener(this.onChange.bind(this));
        try {
            const logo = await WhiteLabel.getClientLogo();
            this.setState({ logo });
        }
        catch (e) {
            console.error('login, failed to get signed URL: ', e);
        }
    }
    componentWillUnmount() {
        SessionStore.removeChangeListener(this.onChange.bind(this));
    }
    onChange() {
        const error = SessionStore.getError();
        if (error !== this.state.error) {
            this.setState({ error });
        }
    }
    validate() {
        const { email, password } = this.state;
        const { t } = this.props;
        if (!email && !password) {
            this.setState({ error: t('ENTER_EMAIL_AND_PASSWORD') });
            return false;
        }
        if (!email || !email.length) {
            this.setState({ error: t('ENTER_EMAIL_TO_CONTINUE') });
            return false;
        }
        if (!password || !password.length) {
            this.setState({ error: t('ENTER_PASSWORD_TO_CONTINUE') });
            return false;
        }
        return true;
    }
    renderLogin() {
        const { email, password, error } = this.state;
        const { t } = this.props;
        return (React.createElement("div", { className: "login-wrapper" },
            React.createElement("div", { className: "login-container w3-animate-opacity" },
                React.createElement("div", { className: "logo flex justify-center" },
                    React.createElement("a", { target: "blank", href: "https://cargomatic.com" },
                        React.createElement("img", { alt: "Cargomatic", src: this.state.logo, style: { height: 30 } }))),
                React.createElement("div", { onKeyDown: this._handleKeyDown, className: "login-input" },
                    React.createElement(CargomaticInput, { id: "login-username", className: "mb-4", value: email, label: t('EMAIL_ADDRESS'), info: t('PLEASE_ENTER_EMAIL'), onChange: (value) => this.updateField(value, 'email'), name: "username", type: "text", autoComplete: "true", autoFocus: true, maxLength: 60 })),
                React.createElement("div", { onKeyDown: this._handleKeyDown, className: "login-input" },
                    React.createElement(CargomaticInput, { id: "login-password", className: "mb-4", value: password, label: t('PASSWORD'), info: t('PLEASE_ENTER_PASSWORD'), onChange: (value) => this.updateField(value, 'password'), name: "password", type: "password", autoComplete: "true" })),
                React.createElement("div", null,
                    React.createElement("button", { id: "login-submit-button", className: "flex items-center mr-5 text-white login-button button button-green w-35", onClick: this.handleLoginButton, disabled: this.state.loading },
                        this.state.loading && (React.createElement(React.Fragment, null,
                            React.createElement(LoadingCircle, { color: "white" }),
                            t('LOGGING_IN'),
                            "...")),
                        !this.state.loading && t('LOGIN'))),
                React.createElement("div", { className: "text-red-500 flex justify-center p-4" }, error && React.createElement("span", null, error)),
                React.createElement("div", { className: "link-container" },
                    React.createElement("span", null,
                        t('NEW_TO_CARGOMATIC'),
                        "?",
                        ' ',
                        React.createElement("a", { target: "blank", href: "https://www.cargomatic.com/signup/?utm_source=cargomatic&utm_medium=brandsite&utm_campaign=carrier_captured_signup_cmdloginsignup_91720&utm_content=noad" }, t('SIGN_UP'))),
                    React.createElement("p", null,
                        React.createElement("a", { onClick: this.handleForgotPassword },
                            t('FORGOT_YOUR_PASSWORD'),
                            "?"))))));
    }
    renderForgotPassword() {
        const { email } = this.state;
        const { t } = this.props;
        return (React.createElement("div", { className: "login-wrapper" },
            React.createElement("div", { className: "login-container" },
                React.createElement("div", { className: "logo" },
                    React.createElement("a", { target: "blank", href: "https://cargomatic.com" },
                        React.createElement("img", { alt: "Cargomatic", src: this.state.logo, style: { height: 30 } }))),
                React.createElement("div", null,
                    React.createElement(CargomaticInput, { value: email, label: t('EMAIL_ADDRESS'), info: t('PLEASE_ENTER_EMAIL'), onChange: (value) => this.updateField(value, 'email'), name: "username", autoFocus: true, maxLength: 60 })),
                React.createElement("div", null,
                    React.createElement("button", { className: "flex items-center mr-5 text-white login-button button button-green w-35", onClick: this.handlePasswordReset, disabled: !email.length }, t('SEND_EMAIL'))),
                React.createElement("div", { className: "link-container" },
                    React.createElement("p", null,
                        React.createElement("a", { onClick: () => this.setState({ mode: 'login', email: '' }) }, t('BACK_TO_LOGIN')))))));
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(CacheBusting, { key: "cache-busting", className: "absolute top-0 left-0 w-full" }),
            this.state.mode === 'login' && this.renderLogin(),
            this.state.mode === 'forgot-password' && this.renderForgotPassword()));
    }
}
Login.contextTypes = {
    router: PropTypes.object.isRequired,
};
export default withTranslation()(Login);
